import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleReativarModelo } from "@/domain/use-cases/modelos";
import { getApiErrorMessage } from "@/utils/normalize-api-error/normalize-api-error";
import { notifyError, notifySuccess } from "@/utils/notify-messages";

export function useReativarModelo() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation({
    mutationFn: async (modelo_id: number) => {
      return await handleReativarModelo(token!, modelo_id);
    },
    onSuccess: async (response: any) => {
      notifySuccess(response?.message ?? "Modelo reativado com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["modelos"] });
      await queryClient.invalidateQueries({ queryKey: ["modelos-por-cliente"] });
      await queryClient.invalidateQueries({ queryKey: ["modelos-unico"] });
    },
    onError: (error) => {
      notifyError(getApiErrorMessage(error));
    },
  });

  return {
    reativarModelo: mutation.mutate,
    reativarModeloAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
